import React from "react"
import { Link } from "gatsby"

import style from "./index.module.css";

export default class Footer extends React.Component {
  render() {
    return (
      <div id="footer" className={style.main}>
        <div className={style.menu}>
          {/* <Link className={style.link} to="/voorwaarden/">Voorwaarden</Link> */}
          <Link className={style.link} to="/over/">Over hilversum100</Link>
          <Link className={style.link} to="/privacy/">Privacy</Link>
          <Link className={style.link} to="/disclaimer/">Disclaimer</Link>
          <Link className={style.link} to="/contact/">Contact</Link>
        </div>
      </div>
    )
  }
}